var layout_default = {
  "layout": "pmKrc",
  "cell": "_-4Amy"
};
export {
  layout_default as default
};
//# sourceMappingURL=layout-scss.js.map
